import { render, staticRenderFns } from "./setting-nickname.vue?vue&type=template&id=83281f24&scoped=true&"
import script from "./setting-nickname.vue?vue&type=script&lang=js&"
export * from "./setting-nickname.vue?vue&type=script&lang=js&"
import style0 from "./setting-nickname.vue?vue&type=style&index=0&id=83281f24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.7_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83281f24",
  null
  
)

export default component.exports